import type { SportType } from '@/types/planTypes';

export const sportColors: Record<SportType, string> = {
  swimming: '#AEE2F3',
  running: '#AEE8B0',
  cycling: '#F2A5A5',
};

export const SPORT_COLOURS: Record<string, string> = {
  RUNNING: '#AEE8B0',
  SWIMMING: '#AEE2F3',
  CYCLING: '#F2A5A5',
  PPG: '#D4B9EB',
};

const NEUTRAL_SPORT_COLOUR = '#E5E7EB';

export const sportColor = (identifier?: string | null): string =>
  (identifier && SPORT_COLOURS[identifier.trim().toUpperCase()]) || NEUTRAL_SPORT_COLOUR;
